// extracted by mini-css-extract-plugin
export default {"container":"alerts_container__DR28J","alertTabs":"alerts_alertTabs__R69bz","tabList":"alerts_tabList__uVeCM"};